var toS = require('./toS')
var isTrue = require('./true')
var isFalse = require('./false')

/**
 * @desc Checks if `value` is classified as a boolean primitive or object.
 * @category Lang
 * @since 3.0.0
 *
 * @param  {*} x value
 * @return {boolean} isBoolean
 *
 * @extends isTrue
 * @extends isFalse
 * @see is/toS
 * @memberOf is
 * @func isBoolean
 *
 * @NOTE could also have typeof x === 'boolean' || (/true|false/).test(x)
 *
 * @example
 *
 *  isBoolean(false)
 *  //=> true
 *  isBoolean(new Boolean(1))
 *  //=> true
 *  isBoolean(1)
 *  //=> false
 *  isBoolean('')
 *  //=> false
 *
 */
module.exports = function (x) { return isTrue(x) || isFalse(x) || toS(x) === '[object Boolean]'; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9vbGVhbi5qcyIsInNvdXJjZXMiOlsiYm9vbGVhbi5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCB0b1MgPSByZXF1aXJlKCcuL3RvUycpXG5jb25zdCBpc1RydWUgPSByZXF1aXJlKCcuL3RydWUnKVxuY29uc3QgaXNGYWxzZSA9IHJlcXVpcmUoJy4vZmFsc2UnKVxuXG4vKipcbiAqIEBkZXNjIENoZWNrcyBpZiBgdmFsdWVgIGlzIGNsYXNzaWZpZWQgYXMgYSBib29sZWFuIHByaW1pdGl2ZSBvciBvYmplY3QuXG4gKiBAY2F0ZWdvcnkgTGFuZ1xuICogQHNpbmNlIDMuMC4wXG4gKlxuICogQHBhcmFtICB7Kn0geCB2YWx1ZVxuICogQHJldHVybiB7Ym9vbGVhbn0gaXNCb29sZWFuXG4gKlxuICogQGV4dGVuZHMgaXNUcnVlXG4gKiBAZXh0ZW5kcyBpc0ZhbHNlXG4gKiBAc2VlIGlzL3RvU1xuICogQG1lbWJlck9mIGlzXG4gKiBAZnVuYyBpc0Jvb2xlYW5cbiAqXG4gKiBATk9URSBjb3VsZCBhbHNvIGhhdmUgdHlwZW9mIHggPT09ICdib29sZWFuJyB8fCAoL3RydWV8ZmFsc2UvKS50ZXN0KHgpXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiAgaXNCb29sZWFuKGZhbHNlKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzQm9vbGVhbihuZXcgQm9vbGVhbigxKSlcbiAqICAvLz0+IHRydWVcbiAqICBpc0Jvb2xlYW4oMSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNCb29sZWFuKCcnKVxuICogIC8vPT4gZmFsc2VcbiAqXG4gKi9cbm1vZHVsZS5leHBvcnRzID0geCA9PiBpc1RydWUoeCkgfHwgaXNGYWxzZSh4KSB8fCB0b1MoeCkgPT09ICdbb2JqZWN0IEJvb2xlYW5dJ1xuIl0sIm5hbWVzIjpbImNvbnN0Il0sIm1hcHBpbmdzIjoiQUFBQUEsR0FBSyxDQUFDLEdBQUcsR0FBRyxPQUFPLENBQUMsT0FBTyxDQUFDO0FBQzVCQSxHQUFLLENBQUMsTUFBTSxHQUFHLE9BQU8sQ0FBQyxRQUFRLENBQUM7QUFDaENBLEdBQUssQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDLFNBQVMsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBOEJsQyxNQUFNLENBQUMsT0FBTyxHQUFHLFVBQUEsQ0FBQyxDQUFBLENBQUMsQUFBRyxTQUFBLE1BQU0sQ0FBQyxDQUFDLENBQUMsSUFBSSxPQUFPLENBQUMsQ0FBQyxDQUFDLElBQUksR0FBRyxDQUFDLENBQUMsQ0FBQyxLQUFLLGtCQUFrQixHQUFBOyJ9